import React from "react";
import styled from "styled-components";

// One manifest for the piece's period icon set. Keeping every use
// behind this component makes a future replacement an asset-only swap.
// Use size 16 for menus/title bars and 32 for desktop icons.

const PNGS = {
  solitaire: {
    16: new URL("./icons/solitaire-16.png", import.meta.url),
    32: new URL("./icons/solitaire-32.png", import.meta.url),
  },
  folder: {
    16: new URL("./icons/folder-16.png", import.meta.url),
    32: new URL("./icons/folder-32.png", import.meta.url),
  },
  "recycle-bin-empty": {
    16: new URL("./icons/recycle-bin-empty-16.png", import.meta.url),
    32: new URL("./icons/recycle-bin-empty-32.png", import.meta.url),
  },
  "recycle-bin-full": {
    16: new URL("./icons/recycle-bin-full-16.png", import.meta.url),
    32: new URL("./icons/recycle-bin-full-32.png", import.meta.url),
  },
  "all-games": {
    16: new URL("./icons/all-games-16.png", import.meta.url),
    32: new URL("./icons/all-games-32.png", import.meta.url),
  },
  settings: {
    16: new URL("./icons/settings-16.png", import.meta.url),
    32: new URL("./icons/settings-32.png", import.meta.url),
  },
  shutdown: {
    16: new URL("./icons/shutdown-16.png", import.meta.url),
    32: new URL("./icons/shutdown-32.png", import.meta.url),
  },
  // MsgIcon resolves `message-${kind}` — same art, dialog-sized.
  "message-shutdown": {
    32: new URL("./icons/shutdown-32.png", import.meta.url),
  },
  "text-file": {
    16: new URL("./icons/text-file-16.png", import.meta.url),
    32: new URL("./icons/text-file-32.png", import.meta.url),
  },
  notepad: {
    16: new URL("./icons/notepad-16.png", import.meta.url),
    32: new URL("./icons/notepad-32.png", import.meta.url),
  },
  speaker: {
    16: new URL("./icons/speaker-16.png", import.meta.url),
    32: new URL("./icons/speaker-32.png", import.meta.url),
  },
  "speaker-loud": {
    16: new URL("./icons/speaker-loud-16.png", import.meta.url),
    32: new URL("./icons/speaker-loud-32.png", import.meta.url),
  },
  key: {
    16: new URL("./icons/key-16.png", import.meta.url),
    32: new URL("./icons/key-32.png", import.meta.url),
  },
  information: {
    16: new URL("./icons/information-16.png", import.meta.url),
    32: new URL("./icons/information-32.png", import.meta.url),
  },
  "message-question": {
    16: new URL("./icons/message-question-16.png", import.meta.url),
    32: new URL("./icons/message-question-32.png", import.meta.url),
  },
  "message-warning": {
    16: new URL("./icons/message-warning-16.png", import.meta.url),
    32: new URL("./icons/message-warning-32.png", import.meta.url),
  },
};

function PixelIcon({ name, size = 16, className }) {
  const set = PNGS[name];
  if (!set) return null;
  const variant = size <= 16 ? set[16] : set[32];
  return (
    <Img
      src={variant.href ?? String(variant)}
      width={size}
      height={size}
      alt=""
      aria-hidden="true"
      className={className}
      // Never let the browser start a native image drag — it fires
      // pointercancel and kills our own drag handling.
      draggable={false}
    />
  );
}

const Img = styled.img`
  image-rendering: pixelated;
  display: inline-block;
  flex-shrink: 0;
  -webkit-user-drag: none;
  -webkit-user-select: none;
  user-select: none;
`;

export default PixelIcon;
